export function getTemplates() {
  return this.get(`/api/prompt_templates`)
}
export function sendPrompt(templateSlug, data) {
  return this.post(`/api/prompt_templates/${templateSlug}/execute`, data)
}

export function sendPromptPy(slug, data) {
  return this.post(`/${slug}`, data, {py: true}).request
}

export function sendPromptBatch(templateSlug, data) {
  return this.post(`/api/prompt_templates/${templateSlug}/execute_batch`, data)
}
export function getPrompts(slug) {
  return this.get(`/api/prompts?prompt_template=${slug}`)
}

export function getPromptsPy(slug) {
  return this.get(`/history?feature=${slug}`, {py: true})
}

export function deletePrompt(id) {
  return this.del(`/history/${id}`, {py: true}).request
}
